/**
 * Tooltip on a feature the owner could enable in a public link but did not (events, tasks, devices, scenes).
 * Visitors are shown the whole product (disabled, not hidden), so one wording serves menu, tabs and settings.
 */
export function publicLinkUnavailableTooltip(): string {
  return $localize`:@@PUBLIC_LINK_FEATURE_UNAVAILABLE:Not available in this public link.`;
}

/** Tooltip on a feature no public link ever offers (providers, documents, interior editor, space management). */
export function publicLinkUnsupportedTooltip(): string {
  return $localize`:@@PUBLIC_LINK_FEATURE_UNSUPPORTED:Not available in public links.`;
}
